/* eslint-disable import/no-extraneous-dependencies */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'lazysizes';
import 'svgxuse';
import 'flickity';

// Individual Bootstrap components
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';

// Site components
import ClassToggler from './modules/classtoggler';
import PrefetchLinks from './modules/prefetchlinks';
import Navigation from './modules/navigation';
import Scrolling from './modules/scrolling';
import FracTracking from './modules/fracs';
import Forms from './modules/forms';
import VideoPlayer from './modules/videoplayer';
import Tracking from './modules/tracking';
import Copy from './modules/copy';
import Cart from './modules/cart';
import HLMap from './modules/hlmap';
import BMICalculator from './modules/bmicalculator';
import LungCancerTool from './modules/lungcancertool';
import SFLSearch from './modules/sflsearch';
import SMC from './modules/smc';
import AddToCart from './modules/addtocart';
import Lists from './modules/lists';

// Site styles
import '../css/app.scss';

// DOM ready:
$(() => {
	$('html').removeClass('no-js');

	// Init common modules
	$('[data-toggle="tooltip"]').tooltip();
	ClassToggler.Init();
	Navigation.Init();
	FracTracking.Init();
	Forms.Init();
	Scrolling.Init();
	Copy.Init();
	Cart.Init();
	Tracking.Init();
	VideoPlayer.Init();
	HLMap.Init();
	BMICalculator.Init();
	LungCancerTool.Init();
	SFLSearch.Init();
	SMC.Init();
	AddToCart.Init();
	Lists.Init();
	// PrefetchLinks should be last
	PrefetchLinks.Init();
});

// All assets loaded
// $(window).on('load', () => { });
